import React from "react";

function About() {
    return (
            <section id="about-group">
                <h1>About Us</h1>
                <p>Each of our sections is run by a Leader in Charge and several Assistant Leaders.
                    <br></br>There may also be a Young Leader or two as part of the team. 
                    <br></br><br></br>Our excellent volunteers dedicate their time to make
                    <br></br> sure that your child has the best experience of Scouting possible.
                </p>
                <h2>Location, Location, Location</h2>
                <p>We meet in St Marks Old Church Hall, Alton Road, Wallisdown.</p>

            </section>
    );
}

export default About;